// Pulls a user-displayable message out of a dj-rest-auth / DRF 400 response
// body. Handles the field-array shape ({field: ["msg", ...]}), the {detail}
// shape, and a raw string. Returns null when nothing usable is found.
export function extractServerErrorMessage(data) {
  if (!data) return null;
  if (typeof data === "string") return data;
  if (data.detail) return data.detail;
  const fields = [
    "new_password2",
    "new_password1",
    "old_password",
    "token",
    "uid",
    "email",
    "non_field_errors",
  ];
  for (const key of fields) {
    const value = data[key];
    if (Array.isArray(value) && value.length) return value[0];
    if (typeof value === "string") return value;
  }
  return null;
}
